declare const SW_ENV: { debug: boolean };
const devToggleLocalStorageKey = "DEVTOGGLELOCALSTORAGEKEY";
const branchNameHiddenLocalStorageKey = "BRANCHNAMEHIDDEN";
type DevTooslState = boolean;

const serializeDevToolsState = (state: DevTooslState): string => {
    return JSON.stringify(state);
};
const deSerializeDevToolsState = (state: string): DevTooslState => {
    return JSON.parse(state);
};

export const isDevToolsOpen = () => {
    if (SW_ENV.debug) {
        //only on dev env.
        const state: DevTooslState = getStateForDevTools();
        return state;
    } else {
        return false;
    }
};
export const toggleDevTools = () => {
    setStateForDevTools(!isDevToolsOpen());
};

export const isBranchNameHidden = () => {
    return (
        deSerializeDevToolsState(localStorage.getItem(branchNameHiddenLocalStorageKey)) ||
        process.env.NODE_ENV !== "development"
    );
};

export const toggleBranchName = () => {
    const state = !isBranchNameHidden();
    localStorage.setItem(branchNameHiddenLocalStorageKey, serializeDevToolsState(state));
    window.location.reload();
};
const setStateForDevTools = (state: DevTooslState) => {
    localStorage.setItem(devToggleLocalStorageKey, serializeDevToolsState(state));
};
export const getStateForDevTools = (): DevTooslState => {
    return deSerializeDevToolsState(localStorage.getItem(devToggleLocalStorageKey));
};
